"use client";

import { useTranslations } from "next-intl";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useCurrentUser } from "@hooks/use-current-user";
import Button from "@components/core/Button";
import Image from "@components/core/Image";
import Link from "@components/core/Link";
import Modal from "@components/core/Modal";
import { subscriptionStatuses } from "@utils/constants/subscriptionStatuses";

function PastDueModal() {
  const t = useTranslations("common");

  const user = useCurrentUser();

  const [showPastDueModal, setShowPastDueModal] = useState(false);

  function handleClose() {
    setShowPastDueModal(false);
    Cookies.set("has-seen-past-due-modal", "true", { expires: 1 });
  }

  useEffect(() => {
    function checkForPastDueModal() {
      if (user.subscription?.state !== subscriptionStatuses.pastDue) return;

      const hasAlreadySeenPastDueModal = JSON.parse(
        Cookies.get("has-seen-past-due-modal") || "false",
      );
      if (hasAlreadySeenPastDueModal) return;

      setShowPastDueModal(true);
    }

    if (user) checkForPastDueModal();
  }, [user]);

  return (
    <Modal
      show={showPastDueModal}
      onHide={handleClose}
      fullscreen
    >
      <div className="d-flex align-items-center justify-content-center h-100 w-100">
        <div
          style={{ width: "100%", maxWidth: "480px" }}
          className="d-flex flex-column align-items-center pb-5 px-3"
        >
          <div
            style={{ maxWidth: "140px" }}
            className="mb-5"
          >
            <Image
              src="handbagSadTertiary"
              alt={t("past_due_modal.img_alt")}
              className="w-100"
            />
          </div>

          <h5 className="text-center mb-3">{t("past_due_modal.title")}</h5>

          <p className="text-center mb-5">{t("past_due_modal.subtitle")}</p>

          <Link
            href="/profile/payment-method"
            className="mb-4"
          >
            <Button onClick={handleClose}>{t("past_due_modal.btn")}</Button>
          </Link>

          <Link
            href="/help/contact-us"
            onClick={handleClose}
          >
            {t("past_due_modal.contact_support")}
          </Link>
        </div>
      </div>
    </Modal>
  );
}

export default PastDueModal;
